import Model from './model'

export default class Deal extends Model {
    /**
     * @returns {string}
     */
    resource() {
        return 'web-api/deal'
    }
}
